import type { Chain } from 'viem'

export const getCurrentChain = (
  chains: ReadonlyArray<Chain>,
  chainId: number
): Chain | undefined => {
  return chains.find(chain => chain.id === chainId)
}
